module.exports = __webpack_public_path__ + "static/img/VIENNA_OAK.3badb69.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/VIENNA_OAK.jpg
// module id = /ksk
// module chunks = 0